module.exports = __webpack_public_path__ + "img/search-header-nav-below-honda.3fe75c3e.png";